import React, { memo, useState, useEffect } from "react";
import { validators } from "investira.sdk";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
} from "investira.react.components";
import { useEntidadesContext } from "../../contexts/EntidadesContext";
import withMessage from "../../hoc/withMessage";

// Constantes para os acessos e tipos
const xAcessosLabels = {
  RLENQ: "Enquadramento",
  RLVAR: "Risco",
  RLDUR: "Duration",
  RLSTT: "Stress Test",
  //   RLBCK: "",
  //   RLCRL: "",
  //   RLFEF: "",
};

const xTipoAcesso = [
  { value: null, label: "Nenhum" },
  { value: "C", label: "Consulta" },
  { value: "E", label: "Edição" },
  { value: "A", label: "Aprovação" },
];

const xDefaultAcessos = {
  RLENQ: null, // Tipo de Acesso
  RLVAR: null,
  RLDUR: null,
  RLSTT: null,
  RLBCK: null,
  RLCRL: null,
  RLFEF: null,
};

const MembroRegras = memo((props) => {
  const { user, onClose } = props;
  const open = !validators.isEmpty(user);
  const { actions } = useEntidadesContext();

  // Inicializa acessos vindo de user.acessos, se houver, ou com o padrão
  const [xAcessos, setXAcessos] = useState(xDefaultAcessos);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setXAcessos({ ...xDefaultAcessos, ...user?.acessos });
    } else {
      setXAcessos(xDefaultAcessos);
    }
  }, [open, user]);

  const handleChangeAcesso = (pKey) => (pEvent) => {
    setXAcessos((xPrev) => ({ ...xPrev, [pKey]: pEvent.target.value }));
  };

  const handleSave = () => {
    setIsSubmitting(true);
    actions.handleModifyMembro(
      {
        usuario_id: user.usuario_id,
        acessos: xAcessos,
      },
      (rRes) => {
        props.onMessageSuccess("Acessos modificados com sucesso.");
        actions.readMembros && actions.readMembros();
        onClose && onClose();
      },
      (rErr) => {
        props.onMessageError("Erro ao modificar acessos.");
      },
      () => {
        setIsSubmitting(false);
      }
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Definir Regras de Acessos</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {Object.keys(xAcessosLabels).map((xKey) => (
            <FormControl fullWidth key={xKey} size="small" variant="outlined">
              <InputLabel id={`label-select-${xKey}`} shrink>
                {xAcessosLabels[xKey]}
              </InputLabel>
              <Select
                labelId={`label-select-${xKey}`}
                label={xAcessosLabels[xKey]}
                value={xAcessos[xKey] ?? ""}
                onChange={handleChangeAcesso(xKey)}
                displayEmpty
              >
                {xTipoAcesso.map((xOpt) => {
                  if (
                    xOpt.value === xTipoAcesso[3].value &&
                    !["RLENQ"].includes(xKey)
                  ) {
                    return null;
                  }

                  return (
                    <MenuItem
                      key={xOpt.value ?? "Sem Acesso"}
                      value={xOpt.value ?? ""}
                    >
                      {xOpt.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="primary" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default withMessage(MembroRegras);
